import { Tooltip as RT } from 'radix-ui';
import type { ReactElement, ReactNode } from 'react';
import { Kbd } from './Kbd.js';
import './overlay.css';

export interface TooltipProps {
  content: ReactNode;
  /** Shortcut chip shown after the text (one shortcut registry feeds tooltips; BUILD-PLAN 3.6). */
  shortcut?: readonly string[];
  side?: 'top' | 'right' | 'bottom' | 'left';
  /** The trigger: a single focusable element. */
  children: ReactElement;
  delayDuration?: number;
}

/** Wrap the app once so tooltips share a skip-delay window. */
export function TooltipProvider({ children }: { children: ReactNode }) {
  return (
    <RT.Provider delayDuration={400} skipDelayDuration={300}>
      {children}
    </RT.Provider>
  );
}

export function Tooltip({
  content,
  shortcut,
  side = 'top',
  children,
  delayDuration,
}: TooltipProps) {
  return (
    <RT.Root {...(delayDuration !== undefined ? { delayDuration } : {})}>
      <RT.Trigger asChild>{children}</RT.Trigger>
      <RT.Portal>
        <RT.Content className="vel-tooltip" side={side} sideOffset={6} collisionPadding={8}>
          <span>{content}</span>
          {shortcut ? <Kbd keys={shortcut} /> : null}
        </RT.Content>
      </RT.Portal>
    </RT.Root>
  );
}
